import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-company">
            <div className="footer-brand">
              <img src="/logo.png" alt="MDG Consulting" className="footer-logo-img" width="50" height="50" loading="lazy" />
            <h3>{t('footer.company')}</h3>
            </div>
            <p>{t('footer.description')}</p>
          </div>

          <div className="footer-links">
            <h4>{t('footer.quickLinks')}</h4>
            <Link to="/">{t('nav.home')}</Link>
            <Link to="/services">{t('nav.services')}</Link>
            <Link to="/case-studies">{t('nav.caseStudies')}</Link>
            <Link to="/contact">{t('nav.contact')}</Link>
          </div>

          <div className="footer-contact">
            <h4>{t('footer.contact')}</h4>
            <a href="mailto:info@mdgconsulting.eu">{t('footer.email')}</a>
            <div className="footer-company-details">
              <p>{t('footer.companyName')}</p>
              <p>{t('footer.companyCode')}</p>
              <p>{t('footer.vatCode')}</p>
              <p>{t('footer.address')}</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} {t('footer.company')}. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
